import { render, staticRenderFns } from "./Levels.vue?vue&type=template&id=0a0d5d3a&scoped=true&"
import script from "./Levels.vue?vue&type=script&lang=ts&"
export * from "./Levels.vue?vue&type=script&lang=ts&"
import style0 from "./Levels.vue?vue&type=style&index=0&id=0a0d5d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0d5d3a",
  null
  
)

export default component.exports